// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"cd566a3a","453":"c09de565","732":"d2958641","977":"a15c2686"}[chunkId] + ".chunk.js";
};